import axiosGraphQL from './GraphQL/axiosGraphQL';
import { SALES_INVOICE_QUERY } from './GraphQL/Queries/SalesInvoiceQuery';
import {
  IGetOrderByCustomer,
  SALES_INVOICE_VARIABLES,
} from './GraphQL/Variables/salesInvoice';

export const SalesInvoiceApis = {
  getOrderByCustomer: async (params: IGetOrderByCustomer) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INVOICE_QUERY.getOrderCustomer,
      variables: SALES_INVOICE_VARIABLES.getOrderByCustomer(params),
    });
  },
};
